function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import AuthorSection from "../molecules/AuthorSection";
import BlockQuote from "../molecules/BlockQuote";
import ImageModal from "../molecules/ImageModal";
import ShareLinks from "../molecules/ShareLinks";
import SidebarCta from "../molecules/SidebarCta";
import BlockTable from "../organisms/PageContent/BlockTable";
import { BlockText } from "../organisms/PageContent/BlockText";
import CustomerCta from "./CustomerCta";
var BlogImage = function(props) {
    var _props_image, _props_image1;
    var image = JSON.parse((_props_image = props.image) === null || _props_image === void 0 ? void 0 : _props_image.source);
    var style = function() {
        switch(props.viewMode){
            case "thumbnail":
                return {
                    width: 240,
                    height: 240
                };
            case "small":
                return {
                    width: 350,
                    height: 350
                };
            case "medium":
                return {
                    width: 500,
                    height: 500
                };
            default:
                return {
                    width: 1024,
                    height: 1024
                };
        }
    };
    var computedStyle = style();
    return ((_props_image1 = props.image) === null || _props_image1 === void 0 ? void 0 : _props_image1.source) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mb-16 flex max-h-full", {
            "justify-center items-center": props.align == "center",
            "justify-start items-start": props.align == "left",
            "justify-end items-end": props.align == "right"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-full",
        style: {
            maxWidth: "".concat(computedStyle.width, "px"),
            maxHeight: "".concat(computedStyle.height, "px")
        }
    }, /*#__PURE__*/ React.createElement("figure", {
        className: "grid justify-items-center"
    }, /*#__PURE__*/ React.createElement("img", {
        src: image === null || image === void 0 ? void 0 : image.src,
        alt: props.image.alt,
        className: "max-w-full h-auto"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "font-medium leading-normal"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.caption
    })))))) : null;
};
var Header = function(param) {
    var _param_level = param.level, level = _param_level === void 0 ? 2 : _param_level, content = param.content, anchor = param.anchor;
    var Heading = "h".concat(level);
    if (typeof content === "string" && content.includes("<")) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, anchor && /*#__PURE__*/ React.createElement("a", {
            id: "".concat(anchor)
        }), /*#__PURE__*/ React.createElement(Heading, {
            dangerouslySetInnerHTML: {
                __html: content
            }
        }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, anchor && /*#__PURE__*/ React.createElement("a", {
        id: "".concat(anchor)
    }), /*#__PURE__*/ React.createElement(Heading, null, content));
};
var IFrameComponent = function(param) {
    var src = param.src, width = param.width, height = param.height, iframeTitle = param.iframeTitle;
    // Check if height is less than 400px or if it's specified as a percentage
    var iframeWidth = width !== null && width !== void 0 ? width : "100%";
    var iframeHeight = height && typeof height === "string" && height.endsWith("%") ? "520" : height === null || height === void 0 ? void 0 : height.trim();
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative pb-[56.25%] h-0 mt-9 mb-11"
    }, /*#__PURE__*/ React.createElement("iframe", {
        src: src,
        width: iframeWidth,
        height: iframeHeight ? iframeHeight : "",
        title: iframeTitle,
        allowFullScreen: true,
        className: "max-w-full absolute w-full h-full left-0 top-0"
    }));
};
export default function BlogContent(props) {
    var _props_content;
    var _props_shareHeading;
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto"
    }, /*#__PURE__*/ React.createElement("article", {
        role: "article",
        className: "md:flex w-full md:gap-x-10 lg:gap-x-32 items-start lg:justify-between"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "md:w-2/3 prose md:max-w-[unset] mb-10"
    }, props === null || props === void 0 ? void 0 : (_props_content = props.content) === null || _props_content === void 0 ? void 0 : _props_content.map(function(block, index) {
        switch(block === null || block === void 0 ? void 0 : block.__typename){
            case "BlockQuote":
                return(// @ts-ignore
                /*#__PURE__*/ React.createElement(BlockQuote, _object_spread({
                    key: index
                }, block)));
            case "BlockHeading":
                return block.level ? /*#__PURE__*/ React.createElement(Header, {
                    key: index,
                    level: block.level,
                    content: block.heading,
                    anchor: block.anchor
                }) : /*#__PURE__*/ React.createElement(Header, {
                    key: index,
                    content: block.heading,
                    anchor: block.anchor
                });
            case "BlockText":
                return /*#__PURE__*/ React.createElement(BlockText, _object_spread({
                    key: index
                }, block));
            case "BlockCustomFrame":
                return /*#__PURE__*/ React.createElement(IFrameComponent, _object_spread({
                    key: index
                }, block));
            case "BlockTable":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "page-container"
                }, /*#__PURE__*/ React.createElement(BlockTable, _object_spread({
                    key: index
                }, block)));
            case "CustomerCta":
                return /*#__PURE__*/ React.createElement("div", {
                    className: "customer-cta-container mt-10 mb-14 first:mt-0"
                }, /*#__PURE__*/ React.createElement(CustomerCta, _object_spread({
                    key: index
                }, block)));
            case "BlockImage":
                return block.openInModal === false ? /*#__PURE__*/ React.createElement(BlogImage, _object_spread({
                    key: index
                }, block)) : /*#__PURE__*/ React.createElement(ImageModal, _object_spread({
                    key: index
                }, block));
        }
    })), /*#__PURE__*/ React.createElement("aside", {
        role: "complementary",
        className: "md:w-1/3 blue-angle-lg relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: 'pt-9 lg:pt-12 pr-9 lg:pr-16 before:content-[""] before:block before:w-0.5 before:bg-blue-200 before:absolute before:top-[115px] before:right-0 before:h-[calc(100%-80px)] before:md:h-[calc(100%-128px)]'
    }, props.blogAuthors && /*#__PURE__*/ React.createElement(AuthorSection, {
        blogAuthors: props.blogAuthors
    }), props.sideCtaHeading && /*#__PURE__*/ React.createElement(SidebarCta, {
        heading: props.sideCtaHeading,
        button: props.sideCtaButton,
        badge: props.sideCtaBadge
    }), props.shareLinks && /*#__PURE__*/ React.createElement(ShareLinks, {
        heading: (_props_shareHeading = props.shareHeading) !== null && _props_shareHeading !== void 0 ? _props_shareHeading : "",
        shareLink: props.shareLinks
    }), /*#__PURE__*/ React.createElement("a", {
        className: "button-secondary focus bg-white border-gray-600 text-gray-100 hover:bg-gray-600 hover:text-white ".concat(props.newsletterCtaClasses)
    }, props.newsletterCtaLabel))))));
}
